import { render, staticRenderFns } from "./editStockholder.vue?vue&type=template&id=c734705a&scoped=true&"
import script from "./editStockholder.vue?vue&type=script&lang=js&"
export * from "./editStockholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c734705a",
  null
  
)

export default component.exports